'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadRecentInstagramPosts = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _reactLocalstorage = require('react-localstorage');

var _reactLocalstorage2 = _interopRequireDefault(_reactLocalstorage);

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _actionTypes = require('../actionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  posts: [],
  isLoading: false
};

function reducer() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case _actionTypes.instagramActions.LOAD_INSTAGRAM_POSTS.STARTED:
      return (0, _extends3.default)({}, state, {
        isLoading: true
      });
    case _actionTypes.instagramActions.LOAD_INSTAGRAM_POSTS.FAILED:
      return (0, _extends3.default)({}, state, {
        isLoading: false,
        error: action.error
      });
    case _actionTypes.instagramActions.LOAD_INSTAGRAM_POSTS.COMPLETED:
      return (0, _extends3.default)({}, state, {
        isLoading: false,
        posts: action.result.data
      });
    default:
      return state;
  }
}

var loadRecentInstagramPosts = exports.loadRecentInstagramPosts = function loadRecentInstagramPosts() {
  return function (dispatch, getState) {
    var auth = getState().auth;
    dispatch({
      types: _actionTypes.instagramActions.LOAD_INSTAGRAM_POSTS.TYPES,
      promise: function promise() {
        return (0, _isomorphicFetch2.default)('https://api.instagram.com/v1/users/self/media/recent/?access_token=' + auth.access_token).then(function (r) {
          return r.json();
        });
      }
    });
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/instagram.js
 ** module id = 459
 ** module chunks = 0
 **/